<form [formGroup]="form" autocomplete="off" class="form-horizontal m-1x mb-3x mt-3x">
  <div class="col-sm-12 col-lg-12 p-0 mb-5x">
    <common-ui-card
      [message]="'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.INFO' | translate"
      type="info">
    </common-ui-card>
  </div>
  <div class="form-row mb-2x">
    <label
      class="col-sm-4 col-form-label"
      for="bezeichnung{{index}}">
      {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.BEZEICHNUNG' | translate }}</label>
    <div class="col-sm-8">
      <input
        class="form-control"
        datevMessagePath="bezeichnung{{objectId}}"
        formControlName="bezeichnung"
        id="bezeichnung{{index}}"
        type="text" utilsCheckValidity utilsControlState
        utilsMarkRequired utilsValidationMessage/>
    </div>
  </div>
  <div class="form-row mb-5x">
    <label class="col-sm-9 col-form-label" for="addressFest">
      {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.FESTOPTION.TITEL' | translate }}
    </label>
    <div class="col-sm-3">
      <select (change)=onAddressFestChanged() class="form-control" datevMessagePath="addressFest{{objectId}}"
              formControlName="addressFest"
              id="addressFest" utilsCheckValidity utilsControlState utilsMarkRequired
              utilsValidationMessage>
        <option [ngValue]="null" selected>
          {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.FESTOPTION.NULL' | translate }}
        </option>
        <option *ngFor="let value of enumKeys(addressFestEnum)" [ngValue]="addressFestEnum[value]">
          {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.FESTOPTION.KEY_'
        + addressFestEnum[value].toUpperCase() | translate }}
        </option>
      </select>
    </div>
  </div>
  <div *ngIf="data.addressFest">
    <div class="mb-5x">
      <h2 class="mb-3x">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.ADRESSE_TITEL' | translate }}
      </h2>
      <common-ui-adresserfassung
        (showInlandsadresseChange)="inlandAddresseShown = $event"
        [(auslandsadresse)]="data.auslandsadresse"
        [(inlandsadresse)]="data.inlandsadresse"
        [disableAuslandsadresse]="data.addressFest == 'NichtFest'"
        [readonly]="readonly"
        [singleMode]=true
        disablePostfachadresse="true">
      </common-ui-adresserfassung>
    </div>
    <div *ngIf="inlandAddresseShown" class="mb-5x">
      <h2 *ngIf="data.addressFest == 'Fest'" class="mb-3x">
        {{'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.EIGENTUM.TITLE_FESTEN_ANLAGEN' | translate}}
      </h2>
      <h2 *ngIf="data.addressFest == 'NichtFest'" class="mb-3x">
        {{'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.EIGENTUM.TITLE_ANLAGEN' | translate}}
      </h2>
      <div *ngIf="!data.eigentum" class="col-sm-12 col-lg-12 p-0 mb-5x">
        <common-ui-card
          [message]="'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.EIGENTUM.ERROR' | translate"
          type="danger">
        </common-ui-card>
      </div>
      <div class="radio-button">
        <div class="radio-button-row">
          <input
            type="radio"
            id="eigentum0"
            [value]="null"
            class="radio-button-selection"
            formControlName="eigentum"
          />
          <label for="eigentum0" class="radio-button-text">
            {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.EIGENTUM.NULL' | translate }}
          </label>
        </div>
        <div class="radio-button-row">
          <input
            [value]="'Gesellschaft'"
            class="radio-button-selection"
            formControlName="eigentum"
            id="eigentum1"
            type="radio"/>
          <label class="radio-button-text" for="eigentum1">
            {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.EIGENTUM.BESITZ' | translate }}
          </label>
        </div>
        <div class="radio-button-row">
          <input
            type="radio"
            id="eigentum2"
            [value]="'Fremdes'"
            class="radio-button-selection"
            formControlName="eigentum"
          />
          <label class="radio-button-text" for="eigentum2">
            {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.BETRIEBSTAETTE.EIGENTUM.FREMDES' | translate }}
          </label>
        </div>
      </div>
    </div>
    <div>
      <h2 class="mb-3x">{{ 'COMMON_UI.BETRIEBSTAETTE.KOMMUNIKATIONSMITTEL_TITEL' | translate }}</h2>
      <common-ui-kommunikationsmittel
        [(data)]="data.kommunikationsmittel"
        [stammdatenTelefonnummern]="stammdaten?.kommunikationsmittel?.telefonnummern"
        [maxTelefonnummern]="maxTelefonnummern">
      </common-ui-kommunikationsmittel>
    </div>
  </div>
</form>
